import React from 'react';
import { IconBase, IconBaseProps } from './IconBase';

export const Search: React.FunctionComponent<IconBaseProps> = (props) => (
  <IconBase {...props} viewBox="0 0 20 20" role="presentation">
    <path d="M18.71,17.29,13.6,12.18a7,7,0,1,0-1.42,1.42l5.11,5.11ZM3,8a5,5,0,1,1,5,5A5,5,0,0,1,3,8Z" />
  </IconBase>
);
